import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Alert, Box, Button, Card, CardContent, CircularProgress, Divider, TextField, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

import { kontakt, verlaengerungAnfragen } from '../api';
import { HINTERGRUND_OEFFENTLICH, Markenkopf } from '../komponenten/Bausteine';
import { fehlertext } from '../utils/format';

// ProfiWare oeffnet diese Seite ueber "Lizenz verlaengern" und gibt Lizenznehmer
// und Hardware-ID als Parameter mit.
export default function Verlaengerung() {
  const [params] = useSearchParams();
  const hardwareId = params.get('hardware_id') || '';
  const [form, setForm] = useState({ name: params.get('kunde') || '', email: '', telefon: '', nachricht: '' });
  const [k, setK] = useState({ telefon: '', email: '' });
  const [fehler, setFehler] = useState('');
  const [laedt, setLaedt] = useState(false);
  const [gesendet, setGesendet] = useState(false);

  useEffect(() => { kontakt().then((r) => setK(r.data)).catch(() => {}); }, []);

  const absenden = async (e) => {
    e.preventDefault();
    setLaedt(true);
    setFehler('');
    try {
      await verlaengerungAnfragen({ ...form, hardware_id: hardwareId });
      setGesendet(true);
    } catch (err) {
      setFehler(fehlertext(err, 'Die Anfrage konnte nicht gesendet werden. Bitte rufen Sie uns an.'));
    } finally {
      setLaedt(false);
    }
  };

  return (
    <Box sx={HINTERGRUND_OEFFENTLICH}>
      <Card sx={{ width: '100%', maxWidth: 480, p: 1 }}>
        <CardContent sx={{ p: 3 }}>
          <Markenkopf
            titel="Lizenz verlängern"
            text={gesendet ? '' : 'Schicken Sie uns kurz Ihre Anfrage – wir melden uns und schalten die Verlängerung frei. ProfiWare übernimmt sie dann von selbst.'}
          />
          {fehler && <Alert severity="error" sx={{ mb: 2 }}>{fehler}</Alert>}

          {gesendet ? (
            <Box sx={{ textAlign: 'center' }}>
              <CheckCircleIcon sx={{ fontSize: 48, color: 'success.main', mb: 1 }} />
              <Typography sx={{ fontWeight: 600, mb: 0.5 }}>Anfrage ist bei uns angekommen</Typography>
              <Typography variant="body2" color="text.secondary">Wir melden uns so schnell wie möglich bei Ihnen.</Typography>
            </Box>
          ) : (
            <Box component="form" onSubmit={absenden} sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <TextField id="anfrage-name" label="Firma / Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} required fullWidth />
              <TextField id="anfrage-email" label="E-Mail" type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} fullWidth />
              <TextField id="anfrage-telefon" label="Telefon" value={form.telefon} onChange={(e) => setForm({ ...form, telefon: e.target.value })} fullWidth helperText="E-Mail oder Telefon – eines von beiden brauchen wir." />
              <TextField id="anfrage-nachricht" label="Nachricht (optional)" value={form.nachricht} onChange={(e) => setForm({ ...form, nachricht: e.target.value })} fullWidth multiline minRows={2} />
              {hardwareId && (
                <Typography variant="caption" color="text.secondary" sx={{ wordBreak: 'break-all' }}>
                  Wird zur Zuordnung mitgeschickt – Hardware-ID: {hardwareId}
                </Typography>
              )}
              <Button type="submit" variant="contained" fullWidth disabled={laedt || !form.name.trim() || (!form.email.trim() && !form.telefon.trim())} sx={{ py: 1.2 }}>
                {laedt ? <CircularProgress size={22} sx={{ color: '#1A1A1A' }} /> : 'Verlängerung anfragen'}
              </Button>
            </Box>
          )}

          {(k.telefon || k.email) && (
            <>
              <Divider sx={{ my: 3 }} />
              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>Oder direkt:</Typography>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {k.telefon && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <PhoneIcon fontSize="small" sx={{ color: '#C49B00' }} /><Typography variant="body2" sx={{ userSelect: 'all' }}>{k.telefon}</Typography>
                  </Box>
                )}
                {k.email && (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <EmailIcon fontSize="small" sx={{ color: '#C49B00' }} /><Typography variant="body2" sx={{ userSelect: 'all' }}>{k.email}</Typography>
                  </Box>
                )}
              </Box>
            </>
          )}
        </CardContent>
      </Card>
    </Box>
  );
}
